import { render, staticRenderFns } from "./App.vue?vue&type=template&id=1b3858f0"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=1b3858f0&prod&lang=css"


/* normalize component */
import normalizer from "!../.pnpm-store/v11/links/@/vue-loader/15.11.1/6eff93d7107be10a36f1ed991dd8c448aca9b1ca7fe7bab80a7f2c3e35a8f285/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports